//My reducer
import { createStore, applyMiddleware, compose } from "redux";
import { persistStore, autoRehydrate } from "redux-persist";
import localForage from "localforage";
import thunkMiddleware from "redux-thunk";
import { createLogger } from "redux-logger";
import rootReducer from "./reducers";

const loggerMiddleware = createLogger({
  colors: true,
});

const createStoreWithMiddleware = applyMiddleware(
  thunkMiddleware,
  loggerMiddleware
);

const initialState = {};

const store = createStore(
  rootReducer,
  initialState,
  compose(createStoreWithMiddleware, autoRehydrate()),
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

persistStore(store, { storage: localForage });

export default store;



// WEBPACK FOOTER //
// ./src/store.js